<template>
  <div v-if="program">
    <HubProgramDetail
      :program="program"
      :breadcrumb="breadcrumb"
      @how-it-works="openHowItWorks"
      @terms="showTerms = true"
      @cta="onCta"
    />

    <TermsModal :isOpen.sync="showTerms" />
    <ConfirmationModal
      v-if="showConfirmation"
      title="Sua participação foi solicitada com sucesso!"
      protocol="HUB-MOCK-001"
      detailIcon="envelope-circle-check"
      detailTitle="Lembrete"
      detailDescription="Em até 5 dias úteis nossa equipe entrará em contato com você."
      @close="showConfirmation = false"
      @action="showConfirmation = false"
    />
  </div>
</template>

<script>
import ConfirmationModal from "@/components/Organisms/ConfirmationModal.vue";
import HubProgramDetail from "@/components/Organisms/HubSaude/HubProgramDetail.vue";
import TermsModal from "@/components/Organisms/CheckupDigitalOmint/TermsModal.vue";
import { getHubProgramBySlug } from "@/data/hubSaude";

export default {
  name: "HubSaudeProgramaDetalhe",
  components: { ConfirmationModal, HubProgramDetail, TermsModal },
  data() {
    return {
      showConfirmation: false,
      showTerms: false
    };
  },
  computed: {
    program() {
      return getHubProgramBySlug(this.$route.params.slug);
    },
    breadcrumb() {
      return [
        { label: "Home", to: "/" },
        { label: "Hub de saúde", to: "/hub-de-saude" },
        { label: "Programas de saúde", to: "/hub-de-saude/programas" },
        { label: this.program?.title || "Programa" }
      ];
    }
  },
  created() {
    if (!this.program) {
      this.$router.replace({ name: "hub_saude.programas" });
    }
  },
  methods: {
    openHowItWorks() {
      this.$router.push({
        name: "hub_saude.como_funciona",
        params: { slug: this.program.slug }
      });
    },
    onCta() {
      if (this.program.ctaKind === "avaliacao") {
        this.$router.push({ name: "programa_saude_2.home" });
        return;
      }
      if (this.program.ctaKind === "navigate" && this.program.route) {
        this.$router.push(this.program.route);
        return;
      }
      this.showConfirmation = true;
    }
  }
};
</script>
